<template>
  <Drawer title="两客一危（省厅）-参数异常" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'gdgovparameterexceptionmodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: false
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: '省厅：设备巡查参数异常',
          // description: '1、ERP历史定位数据管理查询，出现报警：GNSS天线未接或被剪断',
          // content: '2、检测GPS定位天线与设备主机是否松脱,重新插拔GPS定位天线',
          // dispose: '3、安排上门维修更换GPS定位天线',
          imgSrc: '/GDGOV/ParameterException.png'
        },
        {
          title: '锐明',
          description: '1、查询对应报警参数',
          content: '2、修改参数',
          imgSrc: '/RM/AlarmSetting.jpg',
          pdfSrc: '/RM/RM-AlarmSetting.pdf'
        },
        {
          title: '海康',
          description: '1、查询对应报警参数',
          content: '2、修改参数',
          imgSrc: '/HIK/AlarmSetting.jpg',
          pdfSrc: '/HIK/HIK-AlarmSetting.pdf'
        },
        {
          title: '中天',
          description: '1、查询对应报警参数',
          content: '2、修改参数',
          imgSrc: '/ZT/AlarmSetting.jpg',
          pdfSrc: '/ZT/ZT-AlarmSetting.pdf'
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>
</style>
